/* A marca em um lugar só.

   Duas portas, um sobrenome: no painel de quem trabalha é AXIJUD Parceiros,
   no portal do cliente é AXIJUD Benefícios. "Parceiros" não cruza para o lado
   do cliente de propósito: sugere rede de agenciamento, que é o termo que a
   OAB usa para o que é vedado.

   A logo é um arquivo em public/logo.webp, e não um data URL embutido. Embutida
   ela entraria nos DOIS pacotes, e o do portal tem 4,7 kB inteiros para um
   cliente que abre em rede de ramal. Enquanto o arquivo não existir, o
   lettering em texto fica no lugar e nada quebra.

   Este módulo não importa nada, de propósito: ele é usado pelo painel, pelo
   portal e pelo PDF, e qualquer dependência aqui entraria nos três. */

export const MARCA = {
  nome:    "AXIJUD",
  painel:  "Parceiros",
  portal:  "Benefícios",
  arquivo: "/logo.webp",
  /* Duas portas, dois enderecos. O painel vive em parceiros, o portal em
     beneficios, e os dois servem o mesmo build. */
  dominioPainel: "https://parceiros.axijud.com",
  dominioPortal: "https://beneficios.axijud.com",
  preto:   "#1D1D1F",
  amarelo: "#E7B628",
  papel:   "#EFEEEA"
};

export const NOME_PAINEL = `${MARCA.nome} ${MARCA.painel}`;
export const NOME_PORTAL = `${MARCA.nome} ${MARCA.portal}`;

/* Troca o lettering pela logo, se o arquivo existir e for imagem de verdade.
   Falhou, fica o texto: é o mesmo desenho do try/catch da procuração. */
export function trocarPorLogo(alvo, alt){
  if (!alvo || alvo.dataset.comLogo) return;
  const img = new Image();
  img.onload = () => {
    alvo.dataset.comLogo = "1";
    alvo.textContent = "";
    img.alt = alt || "";
    img.className = "logo-img";
    alvo.appendChild(img);
  };
  img.src = MARCA.arquivo;
}
